export default __webpack_public_path__ + "static/media/home_hogar_1.89ebe92e.png";